const zipCodeRegex = new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/);

export default zipCodeRegex;
